@charset "UTF-8";

/* src/app/shared-components/browse-specialties/browse-specialties.component.scss */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root,
  :host {
    --font-sans:
      -apple-system,
      BlinkMacSystemFont,
      "Segoe UI",
      Roboto,
      "Helvetica Neue",
      "Noto Sans",
      Arial,
      sans-serif,
      "Apple Color Emoji",
      "Segoe UI Emoji",
      "Segoe UI Symbol",
      "Noto Color Emoji";
    --font-mono:
      ui-monospace,
      SFMono-Regular,
      Menlo,
      Monaco,
      Consolas,
      "Liberation Mono",
      "Courier New",
      monospace;
    --color-red-50: #fde7e9;
    --color-red-100: #fbced4;
    --color-red-200: #f69ea8;
    --color-red-300: #f26d7d;
    --color-red-400: #ed3d51;
    --color-red-500: #e90c26;
    --color-red-600: #ba0a1e;
    --color-red-700: #8c0717;
    --color-red-800: #5d050f;
    --color-red-900: #2f0208;
    --color-red-950: #170104;
    --color-orange-50: #fdf3e5;
    --color-orange-100: #fbe8cc;
    --color-orange-200: #f8d199;
    --color-orange-300: #f4b966;
    --color-orange-400: #f1a233;
    --color-orange-500: #ed8b00;
    --color-orange-600: #be6f00;
    --color-orange-700: #8e5300;
    --color-orange-800: #5f3800;
    --color-orange-900: #2f1c00;
    --color-orange-950: #180e00;
    --color-green-50: #edf3e6;
    --color-green-100: #dbe6cd;
    --color-green-200: #b8ce9b;
    --color-green-300: #94b56a;
    --color-green-400: #719d38;
    --color-green-500: #4d8406;
    --color-green-600: #3e6a05;
    --color-green-700: #2e4f04;
    --color-green-800: #1f3502;
    --color-green-900: #0f1a01;
    --color-green-950: #080d01;
    --color-blue-50: #e6f2f8;
    --color-blue-100: #cce5f2;
    --color-blue-200: #9acbe4;
    --color-blue-300: #9acbe4;
    --color-blue-400: #3597c9;
    --color-blue-500: #027dbc;
    --color-blue-600: #026496;
    --color-blue-700: #014871;
    --color-blue-800: #01324b;
    --color-blue-900: #001926;
    --color-blue-950: #000d13;
    --color-purple-50: #f1eafa;
    --color-purple-100: #e3d4f6;
    --color-purple-200: #c7a9ed;
    --color-purple-300: #aa7fe3;
    --color-purple-400: #8e54da;
    --color-purple-500: #7229d1;
    --color-purple-600: #5b21a7;
    --color-purple-700: #44197d;
    --color-purple-800: #2e1054;
    --color-purple-900: #17082a;
    --color-purple-950: #0b0415;
    --color-gray-50: oklch(98.5% 0.002 247.839);
    --color-gray-200: oklch(92.8% 0.006 264.531);
    --color-gray-300: oklch(87.2% 0.01 258.338);
    --color-gray-500: oklch(55.1% 0.027 264.364);
    --color-white: #fff;
    --spacing: 0.25rem;
    --container-2xl: 42rem;
    --text-xs: .85rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.5rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-2xl: 2.375rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --font-weight-light: 300;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --font-weight-bold: 700;
    --tracking-wider: 0.05em;
    --leading-tight: 1.25;
    --radius-md: 0.375rem;
    --radius-lg: 0.5rem;
    --radius-3xl: 1.5rem;
    --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --shadow-xl: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --radius: 0.25rem;
    --spacing-0: 0;
    --spacing-1: 0.125rem;
    --spacing-2: 0.25rem;
    --spacing-3: 0.375rem;
    --spacing-4: 0.5rem;
    --spacing-5: 0.75rem;
    --spacing-5\.5: 0.875rem;
    --spacing-6: 1rem;
    --spacing-7: 1.25rem;
    --spacing-8: 1.5rem;
    --spacing-9: 2rem;
    --spacing-10: 2.5rem;
    --spacing-11: 3rem;
    --spacing-12: 4rem;
    --spacing-13: 5rem;
    --spacing-14: 7.5rem;
    --spacing-16: 4rem;
    --spacing-20: 5rem;
    --spacing-24: 6rem;
    --spacing-28: 7rem;
    --spacing-48: 12rem;
    --leading-none: 1;
    --shadow-none: 0 0 #0000;
    --font-myriad:
      myriad-pro,
      "Myriad Pro Fallback",
      sans-serif;
    --color-ama-purple: #46166b;
    --color-ama-blue: #027dbc;
    --color-grey-50: #eeeeef;
    --color-grey-100: #dddcde;
    --color-grey-200: #bbbabe;
    --color-grey-300: #9a979d;
    --color-grey-400: #78757d;
    --color-grey-500: #56525c;
    --color-grey-600: #45424a;
    --color-grey-700: #343137;
    --color-grey-800: #222125;
    --color-grey-900: #222125;
    --color-grey-950: #090809;
    --color-seafoam-50: #e7fbf8;
    --color-seafoam-100: #cff8f2;
    --color-seafoam-200: #9ff1e5;
    --color-seafoam-300: #6fead8;
    --color-seafoam-400: #3fe3cb;
    --color-seafoam-500: #0fdcbe;
    --color-seafoam-600: #0cb098;
    --color-seafoam-700: #098472;
    --color-seafoam-800: #06584c;
    --color-seafoam-900: #032c26;
    --color-seafoam-950: #021613;
    --color-light-grey: #f6f6f8;
    --color-divider-line: #e4e3e6;
    --color-magenta-500: #bc2989;
    --font-kepler:
      "kepler-std",
      "Kepler Std Fallback",
      serif;
    --text-button: 1rem;
    --text-pill: 0.875rem;
    --text-breadcrumb: 0.875rem;
    --text-large: 1.125rem;
    --text-small: 0.875rem;
    --color-primary: var(--color-purple-500);
    --color-text-primary: var(--color-purple-950);
    --color-text-secondary: var(--color-grey-500);
  }
}
@layer base {
  *,
  ::after,
  ::before,
  ::backdrop,
  ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html,
  :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b,
  strong {
    font-weight: bolder;
  }
  code,
  kbd,
  samp,
  pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring:where(:not(iframe)) {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol,
  ul,
  menu {
    list-style: none;
  }
  img,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: block;
    vertical-align: middle;
  }
  img,
  video {
    max-width: 100%;
    height: auto;
  }
  button,
  input,
  select,
  optgroup,
  textarea,
  ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button)) or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
    }
    @supports (color: color-mix(in lab, red, red)) {
      ::placeholder {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit,
  ::-webkit-datetime-edit-year-field,
  ::-webkit-datetime-edit-month-field,
  ::-webkit-datetime-edit-day-field,
  ::-webkit-datetime-edit-hour-field,
  ::-webkit-datetime-edit-minute-field,
  ::-webkit-datetime-edit-second-field,
  ::-webkit-datetime-edit-millisecond-field,
  ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button,
  input:where([type=button], [type=reset], [type=submit]),
  ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden=until-found])) {
    display: none !important;
  }
}
@layer utilities {
  .pointer-events-none {
    pointer-events: none;
  }
  .collapse {
    visibility: collapse;
  }
  .invisible {
    visibility: hidden;
  }
  .visible {
    visibility: visible;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border-width: 0;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .sticky {
    position: sticky;
  }
  .top-2 {
    top: var(--spacing-2);
  }
  .right-4 {
    right: var(--spacing-4);
  }
  .bottom-4 {
    bottom: var(--spacing-4);
  }
  .left-2 {
    left: var(--spacing-2);
  }
  .z-10 {
    z-index: 10;
  }
  .z-30 {
    z-index: 30;
  }
  .col-span-1 {
    grid-column: span 1 / span 1;
  }
  .col-span-2 {
    grid-column: span 2 / span 2;
  }
  .col-span-3 {
    grid-column: span 3 / span 3;
  }
  .col-span-4 {
    grid-column: span 4 / span 4;
  }
  .col-span-5 {
    grid-column: span 5 / span 5;
  }
  .col-span-6 {
    grid-column: span 6 / span 6;
  }
  .col-span-7 {
    grid-column: span 7 / span 7;
  }
  .col-span-8 {
    grid-column: span 8 / span 8;
  }
  .col-span-9 {
    grid-column: span 9 / span 9;
  }
  .col-span-10 {
    grid-column: span 10 / span 10;
  }
  .col-span-11 {
    grid-column: span 11 / span 11;
  }
  .col-span-12 {
    grid-column: span 12 / span 12;
  }
  .container {
    width: 100%;
  }
  @media (width >= 320px) {
    .container {
      max-width: 320px;
    }
  }
  @media (width >= 600px) {
    .container {
      max-width: 600px;
    }
  }
  @media (width >= 768px) {
    .container {
      max-width: 768px;
    }
  }
  @media (width >= 1024px) {
    .container {
      max-width: 1024px;
    }
  }
  @media (width >= 1440px) {
    .container {
      max-width: 1440px;
    }
  }
  @media (width >= 1536px) {
    .container {
      max-width: 1536px;
    }
  }
  .m-2 {
    margin: var(--spacing-2);
  }
  .m-4 {
    margin: var(--spacing-4);
  }
  .m-6 {
    margin: var(--spacing-6);
  }
  .mx-6 {
    margin-inline: var(--spacing-6);
  }
  .mx-auto {
    margin-inline: auto;
  }
  .my-6 {
    margin-block: var(--spacing-6);
  }
  .my-12 {
    margin-block: var(--spacing-12);
  }
  .my-\[1px\] {
    margin-block: 1px;
  }
  .mt-2 {
    margin-top: var(--spacing-2);
  }
  .mt-3 {
    margin-top: var(--spacing-3);
  }
  .mt-4 {
    margin-top: var(--spacing-4);
  }
  .mt-6 {
    margin-top: var(--spacing-6);
  }
  .mt-8 {
    margin-top: var(--spacing-8);
  }
  .mt-25 {
    margin-top: calc(var(--spacing) * 25);
  }
  .mr-3 {
    margin-right: var(--spacing-3);
  }
  .mb-1 {
    margin-bottom: var(--spacing-1);
  }
  .mb-2 {
    margin-bottom: var(--spacing-2);
  }
  .mb-3 {
    margin-bottom: var(--spacing-3);
  }
  .mb-4 {
    margin-bottom: var(--spacing-4);
  }
  .mb-5 {
    margin-bottom: var(--spacing-5);
  }
  .mb-5\.5 {
    margin-bottom: var(--spacing-5\.5);
  }
  .mb-6 {
    margin-bottom: var(--spacing-6);
  }
  .mb-8 {
    margin-bottom: var(--spacing-8);
  }
  .mb-10 {
    margin-bottom: var(--spacing-10);
  }
  .ml-0 {
    margin-left: var(--spacing-0);
  }
  .ml-2 {
    margin-left: var(--spacing-2);
  }
  .ml-4 {
    margin-left: var(--spacing-4);
  }
  .ml-6 {
    margin-left: var(--spacing-6);
  }
  .ml-auto {
    margin-left: auto;
  }
  .\!hidden {
    display: none !important;
  }
  .\!inline-flex {
    display: inline-flex !important;
  }
  .block {
    display: block;
  }
  .contents {
    display: contents;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-block {
    display: inline-block;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .h-5 {
    height: var(--spacing-5);
  }
  .h-6 {
    height: var(--spacing-6);
  }
  .h-8 {
    height: var(--spacing-8);
  }
  .h-12 {
    height: var(--spacing-12);
  }
  .h-16 {
    height: var(--spacing-16);
  }
  .h-20 {
    height: var(--spacing-20);
  }
  .h-24 {
    height: var(--spacing-24);
  }
  .h-\[20px\] {
    height: 20px;
  }
  .h-\[120px\] {
    height: 120px;
  }
  .h-\[210px\] {
    height: 210px;
  }
  .h-full {
    height: 100%;
  }
  .max-h-\[180px\] {
    max-height: 180px;
  }
  .w-5 {
    width: var(--spacing-5);
  }
  .w-5\/6 {
    width: calc(5 / 6 * 100%);
  }
  .w-6 {
    width: var(--spacing-6);
  }
  .w-8 {
    width: var(--spacing-8);
  }
  .w-12 {
    width: var(--spacing-12);
  }
  .w-16 {
    width: var(--spacing-16);
  }
  .w-20 {
    width: var(--spacing-20);
  }
  .w-28 {
    width: var(--spacing-28);
  }
  .w-\[7\.313rem\] {
    width: 7.313rem;
  }
  .w-\[20px\] {
    width: 20px;
  }
  .w-\[120px\] {
    width: 120px;
  }
  .w-\[500px\] {
    width: 500px;
  }
  .w-full {
    width: 100%;
  }
  .max-w-2xl {
    max-width: var(--container-2xl);
  }
  .max-w-\[210px\] {
    max-width: 210px;
  }
  .min-w-0 {
    min-width: var(--spacing-0);
  }
  .min-w-48 {
    min-width: var(--spacing-48);
  }
  .flex-1 {
    flex: 1;
  }
  .flex-shrink-0 {
    flex-shrink: 0;
  }
  .shrink-0 {
    flex-shrink: 0;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .resize {
    resize: both;
  }
  .list-\[initial\] {
    list-style-type: initial;
  }
  .list-disc {
    list-style-type: disc;
  }
  .list-none {
    list-style-type: none;
  }
  .\!grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
  }
  .grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .flex-col {
    flex-direction: column;
  }
  .flex-col-reverse {
    flex-direction: column-reverse;
  }
  .flex-row {
    flex-direction: row;
  }
  .flex-wrap {
    flex-wrap: wrap;
  }
  .items-center {
    align-items: center;
  }
  .items-end {
    align-items: flex-end;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-start {
    justify-content: flex-start;
  }
  .gap-1 {
    gap: var(--spacing-1);
  }
  .gap-2 {
    gap: var(--spacing-2);
  }
  .gap-3 {
    gap: var(--spacing-3);
  }
  .gap-4 {
    gap: var(--spacing-4);
  }
  .gap-5 {
    gap: var(--spacing-5);
  }
  .gap-6 {
    gap: var(--spacing-6);
  }
  .gap-8 {
    gap: var(--spacing-8);
  }
  .gap-10 {
    gap: var(--spacing-10);
  }
  .rounded {
    border-radius: var(--radius);
  }
  .rounded-3xl {
    border-radius: var(--radius-3xl);
  }
  .rounded-full {
    border-radius: calc(infinity * 1px);
  }
  .rounded-lg {
    border-radius: var(--radius-lg);
  }
  .rounded-md {
    border-radius: var(--radius-md);
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .border-b {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 1px;
  }
  .border-b-2 {
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 2px;
  }
  .border-current {
    border-color: currentcolor;
  }
  .border-divider-line {
    border-color: var(--color-divider-line);
  }
  .border-gray-200 {
    border-color: var(--color-gray-200);
  }
  .border-primary {
    border-color: var(--color-primary);
  }
  .bg-ama-blue {
    background-color: var(--color-ama-blue);
  }
  .bg-ama-purple {
    background-color: var(--color-ama-purple);
  }
  .bg-blue-50 {
    background-color: var(--color-blue-50);
  }
  .bg-blue-100 {
    background-color: var(--color-blue-100);
  }
  .bg-blue-200 {
    background-color: var(--color-blue-200);
  }
  .bg-blue-300 {
    background-color: var(--color-blue-300);
  }
  .bg-blue-400 {
    background-color: var(--color-blue-400);
  }
  .bg-blue-500 {
    background-color: var(--color-blue-500);
  }
  .bg-blue-600 {
    background-color: var(--color-blue-600);
  }
  .bg-blue-700 {
    background-color: var(--color-blue-700);
  }
  .bg-blue-800 {
    background-color: var(--color-blue-800);
  }
  .bg-blue-900 {
    background-color: var(--color-blue-900);
  }
  .bg-blue-950 {
    background-color: var(--color-blue-950);
  }
  .bg-divider-line {
    background-color: var(--color-divider-line);
  }
  .bg-gray-200 {
    background-color: var(--color-gray-200);
  }
  .bg-gray-300 {
    background-color: var(--color-gray-300);
  }
  .bg-green-50 {
    background-color: var(--color-green-50);
  }
  .bg-green-100 {
    background-color: var(--color-green-100);
  }
  .bg-green-200 {
    background-color: var(--color-green-200);
  }
  .bg-green-300 {
    background-color: var(--color-green-300);
  }
  .bg-green-400 {
    background-color: var(--color-green-400);
  }
  .bg-green-500 {
    background-color: var(--color-green-500);
  }
  .bg-green-600 {
    background-color: var(--color-green-600);
  }
  .bg-green-700 {
    background-color: var(--color-green-700);
  }
  .bg-green-800 {
    background-color: var(--color-green-800);
  }
  .bg-green-900 {
    background-color: var(--color-green-900);
  }
  .bg-green-950 {
    background-color: var(--color-green-950);
  }
  .bg-grey-50 {
    background-color: var(--color-grey-50);
  }
  .bg-grey-100 {
    background-color: var(--color-grey-100);
  }
  .bg-grey-200 {
    background-color: var(--color-grey-200);
  }
  .bg-grey-300 {
    background-color: var(--color-grey-300);
  }
  .bg-grey-400 {
    background-color: var(--color-grey-400);
  }
  .bg-grey-500 {
    background-color: var(--color-grey-500);
  }
  .bg-grey-600 {
    background-color: var(--color-grey-600);
  }
  .bg-grey-700 {
    background-color: var(--color-grey-700);
  }
  .bg-grey-800 {
    background-color: var(--color-grey-800);
  }
  .bg-grey-900 {
    background-color: var(--color-grey-900);
  }
  .bg-grey-950 {
    background-color: var(--color-grey-950);
  }
  .bg-light-grey {
    background-color: var(--color-light-grey);
  }
  .bg-magenta-500 {
    background-color: var(--color-magenta-500);
  }
  .bg-orange-50 {
    background-color: var(--color-orange-50);
  }
  .bg-orange-100 {
    background-color: var(--color-orange-100);
  }
  .bg-orange-200 {
    background-color: var(--color-orange-200);
  }
  .bg-orange-300 {
    background-color: var(--color-orange-300);
  }
  .bg-orange-400 {
    background-color: var(--color-orange-400);
  }
  .bg-orange-500 {
    background-color: var(--color-orange-500);
  }
  .bg-orange-600 {
    background-color: var(--color-orange-600);
  }
  .bg-orange-700 {
    background-color: var(--color-orange-700);
  }
  .bg-orange-800 {
    background-color: var(--color-orange-800);
  }
  .bg-orange-900 {
    background-color: var(--color-orange-900);
  }
  .bg-orange-950 {
    background-color: var(--color-orange-950);
  }
  .bg-purple-50 {
    background-color: var(--color-purple-50);
  }
  .bg-purple-100 {
    background-color: var(--color-purple-100);
  }
  .bg-purple-200 {
    background-color: var(--color-purple-200);
  }
  .bg-purple-300 {
    background-color: var(--color-purple-300);
  }
  .bg-purple-400 {
    background-color: var(--color-purple-400);
  }
  .bg-purple-500 {
    background-color: var(--color-purple-500);
  }
  .bg-purple-600 {
    background-color: var(--color-purple-600);
  }
  .bg-purple-700 {
    background-color: var(--color-purple-700);
  }
  .bg-purple-800 {
    background-color: var(--color-purple-800);
  }
  .bg-purple-900 {
    background-color: var(--color-purple-900);
  }
  .bg-purple-950 {
    background-color: var(--color-purple-950);
  }
  .bg-red-50 {
    background-color: var(--color-red-50);
  }
  .bg-red-100 {
    background-color: var(--color-red-100);
  }
  .bg-red-200 {
    background-color: var(--color-red-200);
  }
  .bg-red-300 {
    background-color: var(--color-red-300);
  }
  .bg-red-400 {
    background-color: var(--color-red-400);
  }
  .bg-red-500 {
    background-color: var(--color-red-500);
  }
  .bg-red-600 {
    background-color: var(--color-red-600);
  }
  .bg-red-700 {
    background-color: var(--color-red-700);
  }
  .bg-red-800 {
    background-color: var(--color-red-800);
  }
  .bg-red-900 {
    background-color: var(--color-red-900);
  }
  .bg-red-950 {
    background-color: var(--color-red-950);
  }
  .bg-seafoam-50 {
    background-color: var(--color-seafoam-50);
  }
  .bg-seafoam-100 {
    background-color: var(--color-seafoam-100);
  }
  .bg-seafoam-200 {
    background-color: var(--color-seafoam-200);
  }
  .bg-seafoam-300 {
    background-color: var(--color-seafoam-300);
  }
  .bg-seafoam-400 {
    background-color: var(--color-seafoam-400);
  }
  .bg-seafoam-500 {
    background-color: var(--color-seafoam-500);
  }
  .bg-seafoam-600 {
    background-color: var(--color-seafoam-600);
  }
  .bg-seafoam-700 {
    background-color: var(--color-seafoam-700);
  }
  .bg-seafoam-800 {
    background-color: var(--color-seafoam-800);
  }
  .bg-seafoam-900 {
    background-color: var(--color-seafoam-900);
  }
  .bg-seafoam-950 {
    background-color: var(--color-seafoam-950);
  }
  .bg-white {
    background-color: var(--color-white);
  }
  .object-contain {
    object-fit: contain;
  }
  .\!p-0 {
    padding: var(--spacing-0) !important;
  }
  .p-2 {
    padding: var(--spacing-2);
  }
  .p-3 {
    padding: var(--spacing-3);
  }
  .p-4 {
    padding: var(--spacing-4);
  }
  .p-5 {
    padding: var(--spacing-5);
  }
  .p-6 {
    padding: var(--spacing-6);
  }
  .p-8 {
    padding: var(--spacing-8);
  }
  .p-10 {
    padding: var(--spacing-10);
  }
  .px-4 {
    padding-inline: var(--spacing-4);
  }
  .px-6 {
    padding-inline: var(--spacing-6);
  }
  .px-6\! {
    padding-inline: var(--spacing-6) !important;
  }
  .py-2 {
    padding-block: var(--spacing-2);
  }
  .py-5\! {
    padding-block: var(--spacing-5) !important;
  }
  .py-6 {
    padding-block: var(--spacing-6);
  }
  .pt-4 {
    padding-top: var(--spacing-4);
  }
  .pt-8 {
    padding-top: var(--spacing-8);
  }
  .pt-12 {
    padding-top: var(--spacing-12);
  }
  .pr-4 {
    padding-right: var(--spacing-4);
  }
  .pb-2 {
    padding-bottom: var(--spacing-2);
  }
  .pb-6\! {
    padding-bottom: var(--spacing-6) !important;
  }
  .pb-8 {
    padding-bottom: var(--spacing-8);
  }
  .pl-0 {
    padding-left: var(--spacing-0);
  }
  .pl-4 {
    padding-left: var(--spacing-4);
  }
  .text-center {
    text-align: center;
  }
  .align-bottom {
    vertical-align: bottom;
  }
  .font-kepler {
    font-family: var(--font-kepler);
  }
  .font-mono {
    font-family: var(--font-mono);
  }
  .font-myriad {
    font-family: var(--font-myriad);
  }
  .text-2xl {
    font-size: var(--text-2xl);
    line-height: var(--tw-leading, var(--text-2xl--line-height));
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-lg {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xs {
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
  }
  .\!text-\[1\.5rem\] {
    font-size: 1.5rem !important;
  }
  .text-\[2rem\] {
    font-size: 2rem;
  }
  .text-\[11px\] {
    font-size: 11px;
  }
  .text-\[12px\] {
    font-size: 12px;
  }
  .text-\[24px\] {
    font-size: 24px;
  }
  .text-\[25\.5px\] {
    font-size: 25.5px;
  }
  .text-\[32px\] {
    font-size: 32px;
  }
  .text-breadcrumb {
    font-size: var(--text-breadcrumb);
  }
  .text-button {
    font-size: var(--text-button);
  }
  .text-large {
    font-size: var(--text-large);
  }
  .text-pill {
    font-size: var(--text-pill);
  }
  .text-small {
    font-size: var(--text-small);
  }
  .leading-none {
    --tw-leading: var(--leading-none);
    line-height: var(--leading-none);
  }
  .leading-tight {
    --tw-leading: var(--leading-tight);
    line-height: var(--leading-tight);
  }
  .font-bold {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
  .font-light {
    --tw-font-weight: var(--font-weight-light);
    font-weight: var(--font-weight-light);
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .tracking-wider {
    --tw-tracking: var(--tracking-wider);
    letter-spacing: var(--tracking-wider);
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .\!text-white {
    color: var(--color-white) !important;
  }
  .text-\[var\(--color-purple-500\)\] {
    color: var(--color-purple-500);
  }
  .text-\[var\(--color-purple-950\)\] {
    color: var(--color-purple-950);
  }
  .text-blue-500 {
    color: var(--color-blue-500);
  }
  .text-gray-500 {
    color: var(--color-gray-500);
  }
  .text-green-600 {
    color: var(--color-green-600);
  }
  .text-grey-50 {
    color: var(--color-grey-50);
  }
  .text-grey-300 {
    color: var(--color-grey-300);
  }
  .text-grey-400 {
    color: var(--color-grey-400);
  }
  .text-grey-500 {
    color: var(--color-grey-500);
  }
  .text-orange-400 {
    color: var(--color-orange-400);
  }
  .text-orange-500 {
    color: var(--color-orange-500);
  }
  .text-primary {
    color: var(--color-primary);
  }
  .text-purple-500 {
    color: var(--color-purple-500);
  }
  .text-purple-500\! {
    color: var(--color-purple-500) !important;
  }
  .text-purple-600 {
    color: var(--color-purple-600);
  }
  .text-purple-800 {
    color: var(--color-purple-800);
  }
  .text-purple-950 {
    color: var(--color-purple-950);
  }
  .text-red-500 {
    color: var(--color-red-500);
  }
  .text-red-600 {
    color: var(--color-red-600);
  }
  .text-text-primary {
    color: var(--color-text-primary);
  }
  .text-text-secondary {
    color: var(--color-text-secondary);
  }
  .text-text-secondary\! {
    color: var(--color-text-secondary) !important;
  }
  .text-white {
    color: var(--color-white);
  }
  .lowercase {
    text-transform: lowercase;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .ordinal {
    --tw-ordinal: ordinal;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .opacity-0 {
    opacity: 0%;
  }
  .opacity-100 {
    opacity: 100%;
  }
  .shadow {
    --tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / 0.1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / 0.1));
    box-shadow:
      var(--tw-inset-shadow),
      var(--tw-inset-ring-shadow),
      var(--tw-ring-offset-shadow),
      var(--tw-ring-shadow),
      var(--tw-shadow);
  }
  .shadow-01 {
    --tw-shadow: 0 2px 8px 0 var(--tw-shadow-color, rgba(23, 8, 42, 0.04));
    box-shadow:
      var(--tw-inset-shadow),
      var(--tw-inset-ring-shadow),
      var(--tw-ring-offset-shadow),
      var(--tw-ring-shadow),
      var(--tw-shadow);
  }
  .shadow-02 {
    --tw-shadow: 0 4px 16px 0 var(--tw-shadow-color, rgba(23, 8, 42, 0.12));
    box-shadow:
      var(--tw-inset-shadow),
      var(--tw-inset-ring-shadow),
      var(--tw-ring-offset-shadow),
      var(--tw-ring-shadow),
      var(--tw-shadow);
  }
  .blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .transition {
    transition-property:
      color,
      background-color,
      border-color,
      outline-color,
      text-decoration-color,
      fill,
      stroke,
      --tw-gradient-from,
      --tw-gradient-via,
      --tw-gradient-to,
      opacity,
      box-shadow,
      transform,
      translate,
      scale,
      rotate,
      filter,
      -webkit-backdrop-filter,
      backdrop-filter,
      display,
      content-visibility,
      overlay,
      pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .transition-opacity {
    transition-property: opacity;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .ease-in-out {
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
  }
  .select-all {
    -webkit-user-select: all;
    user-select: all;
  }
  @media (hover: hover) {
    .hover\:bg-gray-50:hover {
      background-color: var(--color-gray-50);
    }
    .hover\:bg-grey-50:hover {
      background-color: var(--color-grey-50);
    }
    .hover\:text-purple-800:hover {
      color: var(--color-purple-800);
    }
    .hover\:underline:hover {
      text-decoration-line: underline;
    }
  }
  @media (width < 1024px) {
    .max-lg\:order-4 {
      order: 4;
    }
  }
  @media (width < 768px) {
    .max-md\:order-1 {
      order: 1;
    }
    .max-md\:order-2 {
      order: 2;
    }
    .max-md\:order-3 {
      order: 3;
    }
    .max-md\:order-4 {
      order: 4;
    }
    .max-md\:order-5 {
      order: 5;
    }
    .max-md\:order-6 {
      order: 6;
    }
    .max-md\:order-7 {
      order: 7;
    }
    .max-md\:flex {
      display: flex;
    }
    .max-md\:hidden {
      display: none;
    }
    .max-md\:w-full {
      width: 100%;
    }
    .max-md\:flex-1 {
      flex: 1;
    }
    .max-md\:grid-cols-1\! {
      grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
    }
    .max-md\:flex-col {
      flex-direction: column;
    }
  }
  @media (width >= 768px) {
    .md\:visible {
      visibility: visible;
    }
    .md\:col-span-6 {
      grid-column: span 6 / span 6;
    }
    .md\:\!mt-8 {
      margin-top: var(--spacing-8) !important;
    }
    .md\:mt-6 {
      margin-top: var(--spacing-6);
    }
    .md\:mt-8 {
      margin-top: var(--spacing-8);
    }
    .md\:mt-9 {
      margin-top: var(--spacing-9);
    }
    .md\:mt-\[10px\] {
      margin-top: 10px;
    }
    .md\:mb-1 {
      margin-bottom: var(--spacing-1);
    }
    .md\:mb-5 {
      margin-bottom: var(--spacing-5);
    }
    .md\:mb-6 {
      margin-bottom: var(--spacing-6);
    }
    .md\:mb-8 {
      margin-bottom: var(--spacing-8);
    }
    .md\:mb-12 {
      margin-bottom: var(--spacing-12);
    }
    .md\:ml-4 {
      margin-left: var(--spacing-4);
    }
    .md\:block {
      display: block;
    }
    .md\:flex {
      display: flex;
    }
    .md\:hidden {
      display: none;
    }
    .md\:inline-flex {
      display: inline-flex;
    }
    .md\:h-9 {
      height: var(--spacing-9);
    }
    .md\:w-9 {
      width: var(--spacing-9);
    }
    .md\:w-\[100px\] {
      width: 100px;
    }
    .md\:w-auto {
      width: auto;
    }
    .md\:\!grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .md\:grid-cols-2 {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .md\:grid-cols-3 {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\:grid-cols-3\! {
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .md\:grid-cols-4 {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .md\:flex-row {
      flex-direction: row;
    }
    .md\:gap-x-9 {
      column-gap: var(--spacing-9);
    }
    .md\:object-cover {
      object-fit: cover;
    }
    .md\:pt-8 {
      padding-top: var(--spacing-8);
    }
    .md\:pt-11 {
      padding-top: var(--spacing-11);
    }
    .md\:text-left {
      text-align: left;
    }
  }
  @media (width >= 930px) {
    .min-\[930px\]\:contents {
      display: contents;
    }
    .min-\[930px\]\:hidden {
      display: none;
    }
  }
  @media (width >= 1024px) {
    .lg\:col-span-4 {
      grid-column: span 4 / span 4;
    }
    .lg\:col-span-6 {
      grid-column: span 6 / span 6;
    }
    .lg\:mt-9 {
      margin-top: var(--spacing-9);
    }
    .lg\:mb-8 {
      margin-bottom: var(--spacing-8);
    }
    .lg\:mb-11 {
      margin-bottom: var(--spacing-11);
    }
    .lg\:block {
      display: block;
    }
    .lg\:flex {
      display: flex;
    }
    .lg\:hidden {
      display: none;
    }
    .lg\:gap-8 {
      gap: var(--spacing-8);
    }
    .lg\:pl-\[40px\] {
      padding-left: 40px;
    }
  }
  @media (width >= 1101px) {
    .min-\[1101px\]\:contents {
      display: contents;
    }
    .min-\[1101px\]\:hidden {
      display: none;
    }
  }
  @media (width >= 1440px) {
    .xl\:col-span-3 {
      grid-column: span 3 / span 3;
    }
  }
  .\[\&\:before\]\:font-bold:before {
    --tw-font-weight: var(--font-weight-bold);
    font-weight: var(--font-weight-bold);
  }
}
@font-face {
  font-family: "Myriad Pro Fallback";
  src:
    local("Arial"),
    local("Helvetica Neue"),
    local("Helvetica");
  size-adjust: 96.4%;
  ascent-override: 98.8%;
  descent-override: 25.9%;
  line-gap-override: 0%;
}
@font-face {
  font-family: "Kepler Std Fallback";
  src: local("Georgia"), local("Times New Roman");
  size-adjust: 91.2%;
  ascent-override: 105%;
  descent-override: 28%;
  line-gap-override: 0%;
}
.specialties-container {
  margin-block: var(--spacing-2);
  display: flex;
  height: calc(5 / 6 * 100%);
  flex-wrap: wrap;
  overflow-y: auto;
  padding: var(--spacing-4);
  padding-top: var(--spacing-2);
}
.specialties-container .specialty-item {
  width: 100%;
}
@media (width >= 768px) {
  .specialties-container .specialty-item {
    flex: 1 0 48%;
  }
}
.hide-section {
  display: none;
}
.browse-specialties__sub-nav {
  display: flex;
  width: 100%;
  padding-block: var(--spacing-4);
}
.browse-specialties__sub-nav__toggle {
  display: flex;
  flex: 1;
}
.browse-specialties__sub-nav__search {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.browse-specialties__footer {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  justify-content: flex-end;
  gap: var(--spacing-4);
  padding-block: var(--spacing-4);
}
@media (width >= 1024px) {
  .browse-specialties__footer {
    flex-direction: row;
  }
}
.browse-specialties__footer app-button,
.browse-specialties__footer button {
  width: 100%;
}
@media (width >= 1024px) {
  .browse-specialties__footer app-button,
  .browse-specialties__footer button {
    width: auto;
  }
}
.browse-specialties__footer__count {
  margin-right: auto;
  display: flex;
  width: 100%;
  flex: 1;
  font-size: var(--text-large);
  color: var(--color-grey-600);
}
@media (width >= 1024px) {
  .browse-specialties__footer__count {
    width: auto;
  }
}
@property --tw-rotate-x { syntax: "*"; inherits: false; }
@property --tw-rotate-y { syntax: "*"; inherits: false; }
@property --tw-rotate-z { syntax: "*"; inherits: false; }
@property --tw-skew-x { syntax: "*"; inherits: false; }
@property --tw-skew-y { syntax: "*"; inherits: false; }
@property --tw-border-style { syntax: "*"; inherits: false; initial-value: solid; }
@property --tw-leading { syntax: "*"; inherits: false; }
@property --tw-font-weight { syntax: "*"; inherits: false; }
@property --tw-tracking { syntax: "*"; inherits: false; }
@property --tw-ordinal { syntax: "*"; inherits: false; }
@property --tw-slashed-zero { syntax: "*"; inherits: false; }
@property --tw-numeric-figure { syntax: "*"; inherits: false; }
@property --tw-numeric-spacing { syntax: "*"; inherits: false; }
@property --tw-numeric-fraction { syntax: "*"; inherits: false; }
@property --tw-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-shadow-color { syntax: "*"; inherits: false; }
@property --tw-shadow-alpha { syntax: "<percentage>"; inherits: false; initial-value: 100%; }
@property --tw-inset-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-inset-shadow-color { syntax: "*"; inherits: false; }
@property --tw-inset-shadow-alpha { syntax: "<percentage>"; inherits: false; initial-value: 100%; }
@property --tw-ring-color { syntax: "*"; inherits: false; }
@property --tw-ring-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-inset-ring-color { syntax: "*"; inherits: false; }
@property --tw-inset-ring-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-ring-inset { syntax: "*"; inherits: false; }
@property --tw-ring-offset-width { syntax: "<length>"; inherits: false; initial-value: 0px; }
@property --tw-ring-offset-color { syntax: "*"; inherits: false; initial-value: #fff; }
@property --tw-ring-offset-shadow { syntax: "*"; inherits: false; initial-value: 0 0 #0000; }
@property --tw-blur { syntax: "*"; inherits: false; }
@property --tw-brightness { syntax: "*"; inherits: false; }
@property --tw-contrast { syntax: "*"; inherits: false; }
@property --tw-grayscale { syntax: "*"; inherits: false; }
@property --tw-hue-rotate { syntax: "*"; inherits: false; }
@property --tw-invert { syntax: "*"; inherits: false; }
@property --tw-opacity { syntax: "*"; inherits: false; }
@property --tw-saturate { syntax: "*"; inherits: false; }
@property --tw-sepia { syntax: "*"; inherits: false; }
@property --tw-drop-shadow { syntax: "*"; inherits: false; }
@property --tw-drop-shadow-color { syntax: "*"; inherits: false; }
@property --tw-drop-shadow-alpha { syntax: "<percentage>"; inherits: false; initial-value: 100%; }
@property --tw-drop-shadow-size { syntax: "*"; inherits: false; }
@property --tw-duration { syntax: "*"; inherits: false; }
@property --tw-ease { syntax: "*"; inherits: false; }
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *,
    ::before,
    ::after,
    ::backdrop {
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-border-style: solid;
      --tw-leading: initial;
      --tw-font-weight: initial;
      --tw-tracking: initial;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-duration: initial;
      --tw-ease: initial;
    }
  }
}
/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
